var compressImage = {
  data() {
    return {
      thisFile: null,
      uploadImage: null
    };
  },
  methods: {
    convertBase64UrlToBlob(dataUrl, type) {
      var arr = dataUrl.split(",");
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: type });
    },
    compressImage(path, config) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.src = path;
        img.onload = function() {
          var that = this;
          var w = that.width;
          var h = that.height;
          var scale = w / h;
          if (config) {
            w = config.width || config.height * scale;
            h = config.height || config.width / scale;
          }
          var quality = 0.5; // 默认图片质量为0.7
          // 生成canvas
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          // 创建属性节点
          var anw = document.createAttribute("width");
          anw.nodeValue = w;
          var anh = document.createAttribute("height");
          anh.nodeValue = h;
          canvas.setAttributeNode(anw);
          canvas.setAttributeNode(anh);
          ctx.drawImage(that, 0, 0, w, h);
          if (
            config &&
            config.quality &&
            config.quality <= 1 &&
            config.quality > 0
          ) {
            quality = config.quality;
          }
          var base64 = canvas.toDataURL("image/jpeg", quality);
          // var blob = convertBase64UrlToBlob(base64)
          // 回调函数返回base64的值，也可根据自己的需求返回blob的值
          resolve(base64);
        };
      });
    },
    myCompressImage(file, callback) {
      var config = {
        width: 300,
        height: 300
      };
      this.setCompressImage(file, config, callback);
    },
    setCompressImage(file, config, callback) {
      console.log(file);
      if (!file || file == null || file == undefined) {
        this.$message.error("请选择图片");
        return false;
      }
      if (!/\.(jpg|jpeg|png)$/.test(file.name.toLocaleLowerCase())) {
        this.$message.error("仅支持格式为jpeg,jpg,png的图片");
        return false;
      }
      let that = this;
      this.thisFile = file;
      var quality = 1 - (file.size / 10240000).toFixed(1);
      console.log(
        "图片尺寸：" + file.size / 1000 / 1000 + "M 压缩比例：" + quality
      );
      if (quality < 0) {
        this.$message.error("图片尺寸限制10M以内");
        return false;
      }
      var reader = new FileReader();
      reader.onload = function(e) {
        that
          .compressImage(e.target.result, {
            width: config.width, // 压缩后图片的宽
            height: config.height, // 压缩后图片的高，宽高若只传一个，则按图片原比例进行压缩
            quality: quality // 压缩后图片的清晰度，取值0-1，不传默认为0.7，值越小，所绘制出的图像越模糊
          })
          .then(result => {
            that.uploadImage = result;
            callback(result);
          });
      };
      reader.readAsDataURL(file);
    }
  }
};
export default compressImage = compressImage;



// WEBPACK FOOTER //
// ./src/components/common/compressImage.js